import { apiService } from "@/services/api/apiService";

export interface IPatientInfoResponse {
  num: number;
  lastname: string;
  firstname: string;
  secondname: string;
  birthdatestr: string;
  phone: string;
  cellular: string;
  email: string;
  snils: string;
  address_proj: string;
  count_login: number;
}

export type RawPatientInfoType = Partial<IPatientInfoResponse>;
export type PatientInfoKeysType = keyof IPatientInfoResponse;

export const patientInfoKeys: Array<PatientInfoKeysType> = [
  "num",
  "lastname",
  "firstname",
  "secondname",
  "birthdatestr",
  "phone",
  "cellular",
  "email",
  "snils",
  "address_proj",
  "count_login",
];

export const API_Patient_info = () => {
  return new Promise<RawPatientInfoType>((resolve, reject) => {
    apiService
      .send({
        endpoint: "/patient/info",
        method: "get",
      })
      .then((response) => {
        response = response as RawPatientInfoType;
        if (response && typeof response === "object") {
          const obj: RawPatientInfoType = {};
          const data = patientInfoKeys.reduce(
            (acc: RawPatientInfoType, key: PatientInfoKeysType) => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              acc[key] = response[key];
              return acc;
            },
            obj
          );

          resolve(data);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
